import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { ManageAccounts } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../store';
import { startImpersonation } from '../../store/auth/authSlice';
import { toastService } from '../../services/toast.service';

interface Props {
  userId: number;
  userName: string;
  onSuccess?: () => void;
}

export const ImpersonateButton: React.FC<Props> = ({ userId, userName, onSuccess }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const loading = useAppSelector((state) => state.auth.loading);

  const handleClick = async () => {
    const result = await dispatch(startImpersonation(userId));
    if (startImpersonation.fulfilled.match(result)) {
      toastService.info(`Ви увійшли як ${userName}`);
      onSuccess?.();
      navigate('/dashboard');
    } else {
      toastService.error(
        typeof result.payload === 'string' ? result.payload : 'Не вдалося увійти від імені користувача'
      );
    }
  };

  return (
    <Button
      variant="outlined"
      color="warning"
      startIcon={loading ? <CircularProgress size={16} color="inherit" /> : <ManageAccounts />}
      onClick={handleClick}
      disabled={loading}
    >
      Увійти як {userName}
    </Button>
  );
};
